export default {
	setListOfDealsReview(state, payload) {
		state.listOfDealsReview = payload;
	},
};
